import tipLogo from '../../public/images/tip_logo.png';
import lebenLogo from '../../public/images/leben_logo.png';
import okLogo from '../../public/images/ok_logo.png';
import brigitteLogo from '../../public/images/brigitte_logo.png';
import newMomLogo from '../../public/images/new_mom_logo.png';
import elternLogo from '../../public/images/eltern_logo.png';
import styles from '../../styles/MagazineSlider.module.css';
import { StaticImageData } from 'next/image';

const images: Array<StaticImageData> = [
  tipLogo,
  lebenLogo,
  okLogo,
  brigitteLogo,
  newMomLogo,
  elternLogo,
];

const MagazineSlider = ({ title }: { title: string }) => {
  return (
    <>
      <div className={styles.header}>
        <h6 className="text-center">{title}</h6>
      </div>
      <div className={styles.logos}>
        <div className={styles.slide}>
          {images.map((item, index) => (
            <img key={'1_' + index} src={item.src} alt="" />
          ))}
        </div>
        <div className={styles.slide}>
          {images.map((item, index) => (
            <img key={'2_' + index} src={item.src} alt="" />
          ))}
        </div>
      </div>
    </>
  );
};

export default MagazineSlider;
